import { Id, toast, ToastContentProps, ToastOptions } from "react-toastify";
import CustomAlert from "../components/controls/CustomAlert";

const TOAST_CONFIG: ToastOptions = {
  autoClose: 5000,
  closeOnClick: false,
  hideProgressBar: true,
  closeButton: false,
  position: "bottom-right",
  style: { padding: 0 },
  bodyStyle: { padding: 0 },
};

export class ToastHelper {
  private id: Id;

  /**
   * This method intialises a toast helper instance
   *
   * @param content [content="Loading..."] Starting content of the toast promise waiting to br resolved.
   *
   */
  constructor(loading: boolean = false, content: string = "Loading...") {
    this.id = loading
      ? toast.loading(<CustomAlert severity="info" content={content} />, {
          ...TOAST_CONFIG,
          icon: false,
        })
      : "";
  }

  /**
   *
   * This method is to show the toast with content.
   *
   * @param toastParam
   * @param toastParam.severity  decides the severity of toast (Success, Error, Info)
   * @param toastParam.title  (Optional)  Title of the alert component
   * @param toastParam.content  Content of the alert component
   * @param toastParam.showClose [toastParam.showClose: true] (Optional) option to hide the close button on alert component
   * @param toastParam.options  (Optional) Overide the toast options
   */
  showToast({
    severity,
    title,
    content,
    options,
    showClose = true,
  }: {
    severity: "error" | "success" | "info" | "warn";
    title?: string;
    content: string;
    options?: ToastOptions;
    showClose?: boolean;
  }) {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <CustomAlert
          title={title || severity}
          severity={severity}
          content={content}
          onClose={showClose ? closeToast : undefined}
        />
      ),
      { ...TOAST_CONFIG, ...options }
    );
  }

  /**
   *
   * This method is to update the toast loader with content after the promise is resolved.
   *
   * @param toastParam
   * @param toastParam.severity  decides the severity of toast (Success, Error, Info)
   * @param toastParam.title  (Optional)  Title of the alert component
   * @param toastParam.content  Content of the alert component
   * @param toastParam.showClose [toastParam.showClose: true] (Optional) option to hide the close button on alert component
   * @param toastParam.options  (Optional) Overide the toast options
   */
  updateToast({
    severity,
    title,
    content,
    options,
    showClose = true,
  }: {
    severity: "error" | "success" | "info";
    title?: string;
    content: string;
    options?: ToastOptions;
    showClose?: boolean;
  }) {
    toast.update(this.id, {
      render: ({ closeToast }: ToastContentProps) => (
        <CustomAlert
          title={title || severity}
          severity={severity}
          content={content}
          onClose={showClose ? closeToast : undefined}
        />
      ),
      isLoading: false,
      ...TOAST_CONFIG,
      ...options,
    });
  }
}
